import { render } from "./Setup2FAKey.vue?vue&type=template&id=1eea73f4"
import script from "./Setup2FAKey.vue?vue&type=script&lang=js"
export * from "./Setup2FAKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__